import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TransportVehicleApi } from './transporterVehicles';


export interface TransporterVehiclesInterface {
  id: string;
  name: string;
  address: {
    street: string;
    city: string;
    country: string;
  };
  phone: string;
}

const initialState: TransporterVehiclesInterface = {
  id: '',
  name: '',
  address: {
    street: '',
    city: '',
    country: '',
  },
  phone: '',
};

export const TransporterVehiclesSlice = createSlice({
  name: 'TransporterVehicles',
  initialState,
  reducers: {
    saveTransporterVehicles: (
      state: TransporterVehiclesInterface,
      action: PayloadAction<TransporterVehiclesInterface>
    ) => {
      return { ...state, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        TransportVehicleApi.endpoints.getVehicleById.matchFulfilled,
        (
          state: TransporterVehiclesInterface,
          action: PayloadAction<TransporterVehiclesInterface>
        ) => {
          return { ...state, ...action.payload };
        }
      )
      .addMatcher(
        TransportVehicleApi.endpoints.patchTransporterVehiclesById.matchFulfilled,
        (
          state: TransporterVehiclesInterface,
          action: PayloadAction<TransporterVehiclesInterface>
        ) => {
          return { ...state, ...action.payload };
        }
      );
  },
});

export const { saveTransporterVehicles } = TransporterVehiclesSlice.actions;

export default TransporterVehiclesSlice.reducer;
